import "./App.css";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Bagis from "./Pages/Bagis";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
//import Layout from './Pages/Layout';
import NoPage from "./Pages/NoPage";
//
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GlobalProvider } from "./Context/GlobalState";
//import { GlobalContext } from "./Context/GlobalState";
import { React,useEffect } from "react";
/* MADEN KAMULAŞTIRMA YOLLARI */


import DosyaBilgileri from "./Pages/MadenKamulastirma/DosyaBilgileri";
import TasinmazBilgileri from "./Pages/MadenKamulastirma/TasinmazBilgileri";
import KesifBilgileri from "./Pages/MadenKamulastirma/KesifBilgileri";
import DosyaIncelemesi from "./Pages/MadenKamulastirma/DosyaIncelemesi";
import MunavebeKayit from "./Pages/MunavebeKayit";
import MunavebeUygula from "./Pages/MadenKamulastirma/MunavebeUygula";
import ObjektifUnsurlar from "./Pages/MadenKamulastirma/ObjektifUnsurlar";
import AgacDegerleme from "./Pages/MadenKamulastirma/AgacDegerleme";
import RaporOzet from "./Pages/MadenKamulastirma/RaporOzet";
import ResimEkle from "./Pages/MadenKamulastirma/ResimEkle";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import AvukatKayit from "./Pages/AvukatKayit";
import BilirkisiKayit from "./Pages/BilirkisiKayit";
import NasilKullanilir from "./Pages/NasilKullanilir";

/* ENH KAMULAŞTIRMA YOLLARI */
import EnhDosyaBilgileri from "./Pages/ENHKamulastirma/EnhDosyaBilgileri";
import EnhTasinmazBilgileri from "./Pages/ENHKamulastirma/EnhTasinmazBilgileri";
import EnhKesifBilgileri from "./Pages/ENHKamulastirma/EnhKesifBilgileri";
import EnhDosyaIncelemesi from "./Pages/ENHKamulastirma/EnhDosyaIncelemesi";
import EnhMunavebeUygula from "./Pages/ENHKamulastirma/EnhMunavebeUygula";
import EnhObjektifUnsurlar from "./Pages/ENHKamulastirma/EnhObjektifUnsurlar";
import EnhAgacDegerleme from "./Pages/ENHKamulastirma/EnhAgacDegerleme";
import EnhRaporOzet from "./Pages/ENHKamulastirma/EnhRaporOzet";
import EnhResimEkle from "./Pages/ENHKamulastirma/EnhResimEkle";

/*KARAYOLU KAMULAŞTIRMA YOLLARI*/
import KarayoluDosyaBilgileri from "./Pages/KarayoluKamulastirma/KarayoluDosyaBilgileri";
import KarayoluAgacDegerleme from "./Pages/KarayoluKamulastirma/KarayoluAgacDegerleme";
import KarayoluDosyaIncelemesi from "./Pages/KarayoluKamulastirma/KarayoluDosyaIncelemesi";
import KarayoluKesifBilgileri from "./Pages/KarayoluKamulastirma/KarayoluKesifBilgileri";
import KarayoluMunavebeUygula from "./Pages/KarayoluKamulastirma/KarayoluMunavebeUygula";
import KarayoluObjektifUnsurlar from "./Pages/KarayoluKamulastirma/KarayoluObjektifUnsurlar";
import KarayoluRaporOzet from "./Pages/KarayoluKamulastirma/KarayoluRaporOzet";
import KarayoluResimEkle from "./Pages/KarayoluKamulastirma/KarayoluResimEkle";
import KarayoluTasinmazBilgileri from "./Pages/KarayoluKamulastirma/KarayoluTasinmazBilgileri";

/*ÇOKLU TAŞINMAZ DEĞERLEME*/
import CdTasinmazlar from "./Pages/CokluDegerlerme/CdTasinmazlar";
import CdDosyaBilgileri from "./Pages/CokluDegerlerme/CdDosyaBilgileri";


export default function App() {

  useEffect(() => {
    const onBeforeUnload = () => {
      window.localStorage.clear();
    };

    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);

  return (
    <GlobalProvider>
      <BrowserRouter basename="/">
        <Navbar />
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="/" element={<Login />} />
          {/* MADEN KAMULAŞTIRMA YOLLARI */}
          <Route path="dosyabilgileri" element={<DosyaBilgileri />} />
          <Route path="tasinmazbilgileri" element={<TasinmazBilgileri />} />
          <Route path="kesifbilgileri" element={<KesifBilgileri />} />
          <Route path="dosyaincelemesi" element={<DosyaIncelemesi />} />
          <Route path="munavebeuygula" element={<MunavebeUygula />} />
          <Route path="objektifunsurlar" element={<ObjektifUnsurlar />} />
          <Route path="agacdegerleme" element={<AgacDegerleme />} />
          <Route path="raporozet" element={<RaporOzet />} />
          <Route path="resimekle" element={<ResimEkle />} />

          {/* ENH KAMULAŞTIRMA YOLLARI */}
          <Route path="enhdosyabilgileri" element={<EnhDosyaBilgileri />} />
          <Route
            path="enhtasinmazbilgileri"
            element={<EnhTasinmazBilgileri />}
          />
          <Route path="enhkesifbilgileri" element={<EnhKesifBilgileri />} />
          <Route path="enhdosyaincelemesi" element={<EnhDosyaIncelemesi />} />
          <Route path="enhmunavebeuygula" element={<EnhMunavebeUygula />} />
          <Route path="enhobjektifunsurlar" element={<EnhObjektifUnsurlar />} />
          <Route path="enhagacdegerleme" element={<EnhAgacDegerleme />} />
          <Route path="enhraporozet" element={<EnhRaporOzet />} />
          <Route path="enhresimekle" element={<EnhResimEkle />} />

          {/* KARAYOLU KAMULAŞTIRMA YOLLARI */}
          <Route path="kydosyabilgileri" element={<KarayoluDosyaBilgileri />} />
          <Route
            path="kytasinmazbilgileri"
            element={<KarayoluTasinmazBilgileri />}
          />
          <Route path="kykesifbilgileri" element={<KarayoluKesifBilgileri />} />
          <Route
            path="kydosyaincelemesi"
            element={<KarayoluDosyaIncelemesi />}
          />
          <Route path="kymunavebeuygula" element={<KarayoluMunavebeUygula />} />
          <Route
            path="kyobjektifunsurlar"
            element={<KarayoluObjektifUnsurlar />}
          />
          <Route path="kyagacdegerleme" element={<KarayoluAgacDegerleme />} />
          <Route path="kyraporozet" element={<KarayoluRaporOzet />} />
          <Route path="kyresimekle" element={<KarayoluResimEkle />} />

          {/* ÇOKLU TAŞINMAZ DEĞERLEME */}
          <Route path="cdtasinmazlar" element={<CdTasinmazlar />} />
          <Route path="cddosyabilgileri" element={<CdDosyaBilgileri />} />

          <Route path="bilirkisikayit" element={<BilirkisiKayit />} />
          <Route path="munavebekayit" element={<MunavebeKayit />} />
          <Route path="avukatkayit" element={<AvukatKayit />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="bagis" element={<Bagis />} />
          <Route path="contact" element={<Contact />} />
          <Route path="nasilkullanilir" element={<NasilKullanilir />} />

          <Route path="*" element={<NoPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </GlobalProvider>
  );
}
